module.exports = __webpack_public_path__ + "static/media/Conventional-pathology-two@2x.62353f6f.png";